/* Fila UGC: flechas + pase automatico */
(function () {
  function init(root) {
    if (root.dataset.mlbuReady === '1') return;
    root.dataset.mlbuReady = '1';

    var row = root.querySelector('[data-mlbu-row]');
    var prev = root.querySelector('[data-mlbu-prev]');
    var next = root.querySelector('[data-mlbu-next]');
    if (!row) return;

    var timer = null;
    var activo = root.dataset.auto !== 'false';
    var lento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function anchoItem() {
      var item = row.querySelector('.mlbu__item');
      return item ? item.getBoundingClientRect().width + 5 : 160;
    }

    function sync() {
      if (!prev || !next) return;
      var max = row.scrollWidth - row.clientWidth - 2;
      prev.disabled = row.scrollLeft <= 2;
      next.disabled = row.scrollLeft >= max;
    }

    function pausar() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function parar() {
      activo = false;
      pausar();
    }

    function avanzar() {
      var max = row.scrollWidth - row.clientWidth - 2;
      if (row.scrollLeft >= max) {
        row.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        row.scrollBy({ left: anchoItem(), behavior: 'smooth' });
      }
    }

    function arrancar() {
      if (!activo || lento || timer) return;
      if (row.scrollWidth <= row.clientWidth + 2) return;
      timer = setInterval(avanzar, 3500);
    }

    if (prev) prev.addEventListener('click', function () { parar(); row.scrollBy({ left: -anchoItem() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { parar(); row.scrollBy({ left: anchoItem() * 2, behavior: 'smooth' }); });

    row.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
      row.addEventListener(ev, parar, { passive: true });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { pausar(); } else { arrancar(); }
    });

    sync();
    arrancar();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mlbu]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
